<template>
  <div>
    <!-- <Header/> -->
    <Logo></Logo>
    <div><img :src="image" class="bg1"></div>

    <div style="margin-top:4rem">
        <!-- 两部分，1.岗位 2.副标题部分 -->
    <div class="post" v-for="(list,index) in lists" :key="index" @click="toDetail(index)">
        <div class="post2">
            <!-- 岗位 -->
        <div class="title">{{list.title}}</div>
        <!-- 副标题 -->
        <div class="sub_title">
            <!-- 地点 -->
            <div class="sub_title1">地点：{{list.address}}</div>
            <!-- 人数 -->
            <div style="padding-left:.75rem">|</div>
            <!-- <div class="sub_title2">人数：{{list.count}}</div> -->
            <!-- 学历 -->
            <div class="sub_title3">学历：{{list.acd}}</div>
        </div>
        </div>
    </div>
    </div>
    <div style="height:5.125rem;"><Tabbar></Tabbar></div>
  </div>
</template>
<script>
// import Header from '../../common/FirstHeader.vue'
import Logo from "../Index/Index_components/logo.vue"
import Tabbar from '../Index/Index_components/Tabbar.vue'
import api from '@/utils/api'
export default {
  name: 'Join',
  data () {
    return {
      lists: [],
      image: '',
    }
  },
  created () {
    this.getJoin()
  },
  methods: {
    toDetail(index) {
        this.$router.push({
        path: '/join/detail',
        query: {
          title_name: '',
          JobsList: this.lists[index],
        },
      })
    },
    async getJoin () {
      const { data: data } = await api.getJoin()
      if (data.code === 200) {
        this.image = data.data.image
      }
      const { data: res } = await api.getJobs()
      if (data.code === 200) {
        this.lists = res.data
        console.log('lists', this.lists)
      }
    }
  },
  components: {
    // Header
    Logo,
    Tabbar,
  },
}
</script>

<style scoped>
.bg1 {
  width: 46.875rem;
  height: 14.75rem;
}
/* 岗位部分的定位 */
.post {
  width: 43.875rem;
  height: 9.375rem;
  background-color: #f5f5f5;
  margin-left: auto;
  margin-right: auto;
  margin-top: 2rem;
}
/* 岗位标题 */
.title {
  width: 39.875rem;
  height: 2.625rem;
  font-size: 1.875rem;
  color: #333333;
  padding-top: 2.625rem;
  padding-left: 2rem;
}
/* 次标题 */
.sub_title {
  display: flex;
  font-size: 1.375rem;
  color: #999999;
  padding-top: 0.875rem;
  padding-left: 2rem;
}
.sub_title1 {
  max-width: 16.25rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.sub_title2 {
  margin-left: 1.625rem;
}
.sub_title3 {
  margin-left: .825rem;
}
</style>